// extracted by mini-css-extract-plugin
export default {"asia":"SoutheastAsia_asia__k5OJe","s_w_asia":"SoutheastAsia_s_w_asia__-wtzx"};